import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetFinancialSummaryDto, HirePeriodRange } from '@proxy/register-service/assets';

@Component({
  selector: 'app-hired-assets',
  templateUrl: './hired-assets.component.html',
  styleUrls: ['./hired-assets.component.scss'],
})
export class HiredAssetsComponent {
  @Input() data: AssetFinancialSummaryDto;
  @Output() viewClick = new EventEmitter<string>();
  isModalOpen = false;
  readonly HirePeriodRange = HirePeriodRange;
}
